<template>
  <!--検査品目管理 -->
  <div id="ExamItemsEdit">
    <div id="container">
      <masterNavi v-bind:pageid='"ExamItemsEdit"'></masterNavi>
      <div class="labelTitle lable">検査品目編集</div>
      <section>
        <div class="containtsArea">
            <b-button class="is-primary addRowButton" icon-left="table-row-plus-after" @click="addRow()" :disabled="isEditMode">行追加</b-button>          
            <b-table
                id="examItemsEditTable"
                :data="data"
                >
                <template slot-scope="props">
                    <b-table-column field="id" label="No." width="30" centered>
                        {{props.index + 1}}
                    </b-table-column>
                    <b-table-column field="code" label="品目コード" width="100" centered>
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.itemCode" @input="getItemName(props.row)"/></template>
                        <template v-else>{{props.row.itemCode}}</template>
                    </b-table-column>
                    <b-table-column field="name" label="品目名称" >
                        {{props.row.itemName}}
                    </b-table-column>
                    <b-table-column field="code" label="検査種類" width="400">
                        <template v-if="props.row.mode == 'edit'">
                            <select v-model="props.row.inspectionKind">
                                <option></option>
                                <option v-for="(kind, index) in inspectionKindList" :key="index" :value="kind.value">{{getInspectionName(kind.value)}}</option>
                            </select>
                        </template>
                        <template v-else>{{getInspectionName(props.row.inspectionKind)}}</template>
                    </b-table-column>
                    <b-table-column field="delflg" label="論理削除" width="80" centered>
                        <template v-if="props.row.mode == 'edit'"><input type="checkbox" v-model="props.row.deleteFlag"/></template>
                        <template v-else><input type="checkbox" v-model="props.row.deleteFlag" disabled/></template>
                    </b-table-column>
                    <b-table-column field="edit" label="編集" width="200" centered>
                        <template v-if="props.row.mode == 'edit'">
                            <b-button class="rowButton herfSize is-primary" @click="save(props.index)">保存</b-button>
                            <b-button class="rowButton herfSize is-primary" @click="cancelEdit(props.index)">キャンセル</b-button>
                        </template>
                        <template v-else-if="props.row.mode == 'show'">
                            <b-button class="rowButton is-primary" @click="edit(props.index)">編集</b-button>
                        </template>
                    </b-table-column>
                </template>
            </b-table>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/philips/master/MasterMaintenanceBar";
export default {
  name: "ListEdit",
  methods: {
    edit: function(index) {
        this.originalRowData = JSON.parse(JSON.stringify(this.data[index]));
        this.isEditMode = true;
        for(var rowData of this.data){
            rowData.mode = "none";
        }
        this.data[index].mode = "edit"
    },
    save: async function(index) {
        var item = this.data[index];
        if(item.itemName == ''){
            this.showErrorMessage("正しい品目コードを指定してください。");
            return;
        }
        for(let otherItem of this.data){
            if(otherItem.id == item.id){
                continue;
            }
            if(otherItem.itemCode == item.itemCode){
                if(otherItem.deleteFlag != true){
                    this.showErrorMessage("他で登録されている品目コードです。");
                    return;
                }
            }
        }
        if(!item.inspectionKind || item.inspectionKind == ''){
            this.showErrorMessage("検査種類を選択してください。");
            return;
        }
        // WebAPI Call
        let _this = this;
        await this.apiCall(
            function (client){
                return client.apis.internalMaintenance.setMaintenanceInspectionItemPOST({
                     body: {
                        id: item.id + "",
                        itemCode: item.itemCode,
                        inspectionKind: item.inspectionKind,
                        deleteFlag: item.deleteFlag,
                     }
                 });
            },
            function(result) {
                _this.data[index].id = result.obj.id;
                _this.originalRowData = null;
                _this.isEditMode = false;
                for(var rowData of _this.data){
                    rowData.mode = "show";
                }
            },
            function(result) {
                _this.showErrorMessage(result);
            },
        );
    },
    addRow: function() {
        this.originalRowData = "addRow";
        this.isEditMode = true;
        for(var rowData of this.data){
            rowData.mode = "none";
        }
        this.data.push(
            {mode:"edit",id:"-", itemCode:"", itemName:"" ,inspectionKind:"",vname:"",deleteFlag:false},
        );
    },
    cancelEdit: function(index) {
        if(this.originalRowData == "addRow"){
            this.data.splice(this.data.length-1, 1);
        } else {
            this.data[index] = this.originalRowData;
        }
        this.isEditMode = false;
        for(var rowData of this.data){
            rowData.mode = "show";
        }
    },
    getItemName: function(row){
        // WebAPI Call
        let _this = this;
        this.apiAnsyncCall(
            function (client){
                return client.apis.apiCommon.getItemNamePOST({
                     body: {
                        itemCode: row.itemCode
                     }
                 });
            },
            function(result) {
                row.itemName = result.obj.itemName;
            },
             function(result) {
                row.itemName = result.obj.itemName;
            },
        );
    },
    getInspectionName: function(inspectionCode){
        let ret = "";
        let item = this.inspectionKindList.find(item => { return item.value ==  inspectionCode;})
        if(item){
            ret = item.label1;
        }
        return ret;
    },
    getInspectionKindList: function(){
        // WebAPI Call
        let _this = this;
        this.apiCall(
            function (client){
                return client.apis.apiCommon.getInspectionKindListPOST({
                     body: {
                     }
                 });
            },
            function(result) {
                _this.inspectionKindList = result.obj;
            },
             function(result) {
            },
        );
    },
    getInspectionItemList: function(){
        // WebAPI Call
        let _this = this;
        this.apiCall(
            function (client){
                return client.apis.apiCommon.getInspectionItemListPOST({
                     body: {
                         includeDelete: true
                     }
                 });
            },
            function(result) {
                for(let item of result.obj){
                    item["mode"] = "show";
                 }
                _this.data = result.obj;
            },
             function(result) {
            },
        );
    },
  },
  data() {
    return {
      data:[],
      inspectionKindList: [],
      isEditMode: false,
      originalRowData:{}
    };
  },
  filters: {},
  components: {
    masterNavi: naviBar,
  },
  mounted: async function(){
      await this.getInspectionKindList();
      await this.getInspectionItemList();
  }
};
</script>
<style lang="scss" scoped>

.containtsArea {
  margin-top:10px;
}
.rowButton {
    height: 30px;
}
.rowButton.herfSize {
    width: 48%;
}
.addRowButton {
    float: right;
    margin-right: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/master/list/ExamItemsEdit.vue